module.exports = __webpack_public_path__ + "img/imgTextAndImageRightSection.b7283c68.webp";